// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ma-1";
export var messageSideRight = "_ma-2";
export var subscribeToBackInStockBubbleContainer = "_ma-0";